module.exports = __webpack_public_path__ + "static/media/sweat-onboarding.9a3ad0fd.png";